var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm._l(_vm.editableAreaInfo, function (item, index) {
    return _c("div", {
      key: item.id
    }, [_c("top-title", [_c("span", {
      attrs: {
        slot: "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.$t(item.controlTitle)))]), item.controlType == "controlGroup" && item.other == 1 ? _c("div", {
      attrs: {
        slot: "btn"
      },
      slot: "btn"
    }, [_c("a-button", {
      on: {
        click: function ($event) {
          return _vm.addItemFun(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("新增")))])], 1) : _vm._e(), item.controlType == "controlGroup" && item.delete == 1 ? _c("div", {
      attrs: {
        slot: "btn"
      },
      slot: "btn"
    }, [_c("a-button", {
      on: {
        click: function ($event) {
          return _vm.deleteItemFun(index);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("删除")))])], 1) : _vm._e(), item.controlType == "table" && item.operation == "addEditDel" ? _c("div", {
      attrs: {
        slot: "btn"
      },
      slot: "btn"
    }, [_c("a-button", {
      on: {
        click: function ($event) {
          return _vm.addTableFun(null, index, item.operation);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("新增")))])], 1) : _vm._e()]), item.controlType != "table" ? _c("div", _vm._l(item.control, function (item2, index2) {
      return _c("div", {
        key: index2,
        staticClass: "controlItem"
      }, [_c("div", {
        staticClass: "nameBox"
      }, [item2.other ? _c("span", [_vm._v("*")]) : _vm._e(), _vm._v(_vm._s(_vm.$t(item2.controlName)) + " "), _c("a-tooltip", [_c("template", {
        slot: "title"
      }, [_vm._v(" " + _vm._s(item2.controlExplain) + " ")]), item2.controlExplain ? _c("a-icon", {
        staticStyle: {
          margin: "0 3px"
        },
        attrs: {
          type: "question-circle"
        }
      }) : _vm._e()], 2), _vm._v(" : ")], 1), _c("div", {
        staticClass: "contBox"
      }, [item2.partsType == "singleLine" ? _c("a-input", {
        attrs: {
          placeholder: _vm.$t(item2.promptText)
        },
        model: {
          value: item2.value,
          callback: function ($$v) {
            _vm.$set(item2, "value", $$v);
          },
          expression: "item2.value"
        }
      }) : _vm._e(), item2.partsType == "multiline" ? _c("a-textarea", {
        attrs: {
          placeholder: _vm.$t(item2.promptText)
        },
        model: {
          value: item2.value,
          callback: function ($$v) {
            _vm.$set(item2, "value", $$v);
          },
          expression: "item2.value"
        }
      }) : _vm._e(), item2.partsType == "singleChoice" ? _c("a-radio-group", {
        model: {
          value: item2.value,
          callback: function ($$v) {
            _vm.$set(item2, "value", $$v);
          },
          expression: "item2.value"
        }
      }, _vm._l(item2.optionList, function (item3, index3) {
        return _c("a-radio", {
          key: index3,
          attrs: {
            value: item3
          }
        }, [_vm._v(" " + _vm._s(item3) + " ")]);
      }), 1) : _vm._e(), item2.partsType == "multipleChoice" ? _c("a-checkbox-group", {
        attrs: {
          options: item2.optionList
        },
        model: {
          value: item2.value,
          callback: function ($$v) {
            _vm.$set(item2, "value", $$v);
          },
          expression: "item2.value"
        }
      }) : _vm._e(), item2.partsType == "dropDown" ? _c("a-select", {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          placeholder: _vm.$t(item2.promptText)
        },
        model: {
          value: item2.value,
          callback: function ($$v) {
            _vm.$set(item2, "value", $$v);
          },
          expression: "item2.value"
        }
      }, _vm._l(item2.optionList, function (item3, index3) {
        return _c("a-select-option", {
          key: index3,
          attrs: {
            value: item3
          }
        }, [_vm._v(" " + _vm._s(item3) + " ")]);
      }), 1) : _vm._e(), item2.partsType == "hierarchy" && item2.type == "province" ? _c("area-select", {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          placeholder: _vm.$t(item2.promptText),
          index: index,
          index2: index2
        },
        on: {
          change: _vm.selectArea
        }
      }) : _vm._e(), item2.partsType == "hierarchy" && item2.type == "country" ? _c("country", {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          placeholder: _vm.$t(item2.promptText),
          index: index,
          index2: index2
        },
        on: {
          change: _vm.selectCountry
        }
      }) : _vm._e(), item2.partsType == "date" && item2.dateType == 1 || item2.partsType == "date" && !item2.dateType ? _c("a-date-picker", {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          format: _vm.getFormatDate()
        },
        on: {
          change: function ($event) {
            return _vm.onDateChange(item2.value, index, index2);
          }
        },
        model: {
          value: item2.value,
          callback: function ($$v) {
            _vm.$set(item2, "value", $$v);
          },
          expression: "item2.value"
        }
      }) : _vm._e(), item2.partsType == "date" && item2.dateType == 3 ? _c("a-date-picker", {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          "show-time": "",
          format: _vm.getFormatDate() + "HH:mm" + _vm.dateChronaxie()
        },
        on: {
          change: function ($event) {
            return _vm.onDateChange(item2.value, index, index2);
          }
        },
        model: {
          value: item2.value,
          callback: function ($$v) {
            _vm.$set(item2, "value", $$v);
          },
          expression: "item2.value"
        }
      }) : _vm._e(), item2.partsType == "dateRange" && item2.dateType == 1 || item2.partsType == "dateRange" && !item2.dateType ? _c("a-range-picker", {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          format: _vm.getFormatDate()
        },
        model: {
          value: item2.value,
          callback: function ($$v) {
            _vm.$set(item2, "value", $$v);
          },
          expression: "item2.value"
        }
      }) : _vm._e(), item2.partsType == "dateRange" && item2.dateType == 3 ? _c("a-range-picker", {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          "show-time": {
            format: "HH:mm"
          },
          format: _vm.getFormatDate() + "HH:mm" + _vm.dateChronaxie()
        },
        model: {
          value: item2.value,
          callback: function ($$v) {
            _vm.$set(item2, "value", $$v);
          },
          expression: "item2.value"
        }
      }) : _vm._e(), item2.partsType == "picture" || item2.partsType == "enclosure" ? _c("div", {
        staticClass: "pictureBox"
      }, [_c("picture-item", {
        attrs: {
          pictureList: [],
          index: index,
          index2: index2,
          uploadAccept: _vm.toChangeUploadAccept(item2.fileFormat),
          partsType: item2.partsType
        },
        on: {
          pictureOk: _vm.pictureOk
        }
      }), item2.fileFormat.length != 0 ? _c("div", [_vm._v("*" + _vm._s(_vm.$t("文件格式")) + "（" + _vm._s(item2.fileFormat.join(",")) + "）")]) : _vm._e(), item2.template.length != 0 ? _c("div", {
        staticClass: "ant-btn-link",
        staticStyle: {
          cursor: "pointer"
        },
        on: {
          click: function ($event) {
            return _vm.onModalPreview(item2.template);
          }
        }
      }, [_vm._v(" " + _vm._s(_vm.$t("模板预览")) + " ")]) : _vm._e()], 1) : _vm._e()], 1)]);
    }), 0) : _c("div", {
      staticClass: "marginB20"
    }, [_c("a-table", {
      key: _vm.tableKey,
      staticClass: "marginT20",
      attrs: {
        bordered: "",
        columns: item.control,
        rowKey: "id",
        "data-source": item.value,
        pagination: false,
        scroll: {
          x: item.operation == "addEditDel" ? 0 : 1300
        }
      },
      scopedSlots: _vm._u([{
        key: "index",
        fn: function (text, record, index) {
          return [_vm._v(" " + _vm._s(index + 1) + " ")];
        }
      }, {
        key: "photo",
        fn: function (text, record) {
          return _vm._l(record.photo, function (item, index) {
            return _c("img", {
              key: index,
              staticStyle: {
                width: "50px",
                height: "50px",
                "margin-right": "5px"
              },
              attrs: {
                src: item
              }
            });
          });
        }
      }, {
        key: "loss",
        fn: function (text, record) {
          return [_c("a-input", {
            attrs: {
              placeholder: _vm.$t("请输入") + _vm.$t("定损意见")
            },
            model: {
              value: record.loss,
              callback: function ($$v) {
                _vm.$set(record, "loss", $$v);
              },
              expression: "record.loss"
            }
          })];
        }
      }, {
        key: "damage",
        fn: function (text, record) {
          return [_c("a-input", {
            attrs: {
              placeholder: _vm.$t("请输入") + _vm.$t("核损意见")
            },
            model: {
              value: record.damage,
              callback: function ($$v) {
                _vm.$set(record, "damage", $$v);
              },
              expression: "record.damage"
            }
          })];
        }
      }, {
        key: "action",
        fn: function (text, record, num) {
          return [_c("a-button", {
            staticClass: "marginR15",
            attrs: {
              type: "edit"
            },
            on: {
              click: function ($event) {
                return _vm.addTableFun(record, index, item.operation);
              }
            }
          }, [_vm._v(_vm._s(_vm.$t("编辑")))]), _c("a-button", {
            attrs: {
              type: "danger"
            },
            on: {
              click: function ($event) {
                return _vm.delTableFun(index, num);
              }
            }
          }, [_vm._v(_vm._s(_vm.$t("删除")))])];
        }
      }], null, true)
    }, _vm._l(item.control, function (item, i) {
      return _c("span", {
        key: i,
        attrs: {
          slot: item.slots.title
        },
        slot: item.slots.title
      }, [_vm._v(_vm._s(_vm.$t(item.slots.title)))]);
    }), 0)], 1)], 1);
  }), _vm.tableShow ? _c("table-model", {
    ref: "tableFrom",
    on: {
      cancel: function ($event) {
        _vm.tableShow = false;
      },
      tableOk: _vm.tableOk
    }
  }) : _vm._e(), _c("preview-list-modal", {
    attrs: {
      previewVisible: _vm.previewListVisible,
      fileList: _vm.modalPreviewList
    },
    on: {
      cancel: function ($event) {
        _vm.previewListVisible = false;
      }
    }
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };